import { Row } from './components/ApiKeyTable';
import { Graph } from './type';

export const entities: Graph[] = [
  {
    id: 'graph1',
    name: 'Acme-Corp-Graph',
    type: 'graph',
    variants: [
      {
        id: 'variant1',
        name: 'Acme-Prod-Variant',
        type: 'variant',
        subgraphs: [
          {
            id: 'subgraph1',
            name: 'Acme-Prod-Identity-Subgraph',
            type: 'subgraph',
          },
          {
            id: 'subgraph2',
            name: 'Acme-Prod-Analytics-Subgraph',
            type: 'subgraph',
          },
        ],
      },
      {
        id: 'variant2',
        name: 'Acme-Staging-Variant',
        type: 'variant',
        subgraphs: [
          {
            id: 'subgraph3',
            name: 'Acme-Staging-Auth-Subgraph',
            type: 'subgraph',
          },
        ],
      },
    ],
  },
  {
    id: 'graph2',
    name: 'FancyCorp-Graph',
    type: 'graph',
    variants: [
      {
        id: 'variant3',
        name: 'FancyCorp-Prod',
        type: 'variant',
        subgraphs: [
          {
            id: 'subgraph4',
            name: 'FancyCorp-Prod-Catalog-Subgraph',
            type: 'subgraph',
          },
        ],
      },
      {
        id: 'variant4',
        name: 'FancyCorp-Staging',
        type: 'variant',
        subgraphs: [
          {
            id: 'subgraph5',
            name: 'FancyCorp-Staging-Orders-Subgraph',
            type: 'subgraph',
          },
        ],
      },
    ],
  },
];

export const mockData: Row[] = [
  {
    name: 'prod-1',
    type: 'graph',
    role: 'Graph Admin',
    entity: 'Acme-Graph',
    createdBy: 'John Doe',
    createdAt: new Date('2024-03-15T10:30:00Z').getTime(),
    lastUsed: new Date('2024-03-20T15:45:00Z').getTime(),
  },
  {
    name: 'main-prod',
    type: 'organization',
    role: 'Graph Admin',
    entity: 'Acme-Graph',
    createdBy: 'John Dane',
    createdAt: new Date('2024-02-15T10:30:00Z').getTime(),
    lastUsed: new Date('2024-03-20T15:45:00Z').getTime(),
  },
  {
    name: 'dev-sandbox',
    type: 'graph',
    role: 'Observer',
    entity: 'Acme-Graph',
    createdBy: 'Jane Smith',
    createdAt: new Date('2024-03-10T09:15:00Z').getTime(),
    lastUsed: new Date('2024-03-19T11:20:00Z').getTime(),
  },
  {
    name: 'staging-access',
    type: 'variant',
    role: 'Contributor',
    entity: 'Staging-Acme-Variant',
    createdBy: 'Alex Wong',
    createdAt: new Date('2024-03-05T14:00:00Z').getTime(),
    lastUsed: new Date('2024-03-18T16:30:00Z').getTime(),
  },
  {
    name: 'qa-test',
    type: 'subgraph',
    role: 'Contributor',
    entity: 'Staging-Acme-Identity-Subgraph',
    createdBy: 'Sarah Jones',
    createdAt: new Date('2024-03-01T11:45:00Z').getTime(),
    lastUsed: new Date('2024-03-17T13:15:00Z').getTime(),
  },
  {
    name: 'prod-backup',
    type: 'variant',
    role: 'Contributor',
    entity: 'Prod-Acme-Variant',
    createdBy: 'Mike Brown',
    createdAt: new Date('2024-02-28T16:20:00Z').getTime(),
    lastUsed: new Date('2024-03-16T09:40:00Z').getTime(),
  },
  {
    name: 'analytics',
    type: 'graph',
    role: 'Observer',
    entity: 'Prod-Acme-Analytics-Subgraph',
    createdBy: 'Emily Chen',
    createdAt: new Date('2024-02-25T11:30:00Z').getTime(),
    lastUsed: new Date('2024-03-15T14:20:00Z').getTime(),
  },
  {
    name: 'monitoring',
    type: 'variant',
    role: 'Contributor',
    entity: 'Prod-Acme-Monitoring-Subgraph',
    createdBy: 'David Kim',
    createdAt: new Date('2024-02-20T09:45:00Z').getTime(),
    lastUsed: new Date('2024-03-14T16:15:00Z').getTime(),
  },
  {
    name: 'testing',
    type: 'subgraph',
    role: 'Contributor',
    entity: 'Test-Graph',
    createdBy: 'Lisa Wang',
    createdAt: new Date('2024-02-15T13:20:00Z').getTime(),
    lastUsed: new Date('2024-03-13T10:30:00Z').getTime(),
  },
  {
    name: 'development',
    type: 'graph',
    role: 'Graph Admin',
    entity: 'Dev-Graph',
    createdBy: 'Tom Wilson',
    createdAt: new Date('2024-02-10T15:40:00Z').getTime(),
    lastUsed: new Date('2024-03-12T11:45:00Z').getTime(),
  },
  {
    name: 'production',
    type: 'variant',
    role: 'Contributor',
    entity: 'Prod-Graph',
    createdBy: 'Rachel Lee',
    createdAt: new Date('2024-02-05T10:15:00Z').getTime(),
    lastUsed: new Date('2024-03-11T09:20:00Z').getTime(),
  },
  {
    name: 'staging',
    type: 'subgraph',
    role: 'Observer',
    entity: 'Staging-Graph',
    createdBy: 'Chris Martinez',
    createdAt: new Date('2024-02-01T14:30:00Z').getTime(),
    lastUsed: new Date('2024-03-10T13:40:00Z').getTime(),
  },
  {
    name: 'qa',
    type: 'graph',
    role: 'Contributor',
    entity: 'QA-Graph',
    createdBy: 'Sophie Taylor',
    createdAt: new Date('2024-01-28T11:20:00Z').getTime(),
    lastUsed: new Date('2024-03-09T15:30:00Z').getTime(),
  },
  {
    name: 'monitoring-2',
    type: 'variant',
    role: 'Graph Admin',
    entity: 'Monitoring-Graph-2',
    createdBy: 'James Anderson',
    createdAt: new Date('2024-01-25T09:10:00Z').getTime(),
    lastUsed: new Date('2024-03-08T14:15:00Z').getTime(),
  },
  {
    name: 'analytics-2',
    type: 'subgraph',
    role: 'Contributor',
    entity: 'Analytics-Graph-2',
    createdBy: 'Emma Garcia',
    createdAt: new Date('2024-01-20T16:45:00Z').getTime(),
    lastUsed: new Date('2024-03-07T10:25:00Z').getTime(),
  },
  {
    name: 'development-2',
    type: 'graph',
    role: 'Observer',
    entity: 'Dev-Graph-2',
    createdBy: 'Daniel Park',
    createdAt: new Date('2024-01-15T13:30:00Z').getTime(),
    lastUsed: new Date('2024-03-06T11:50:00Z').getTime(),
  },
];
